module.exports = __webpack_public_path__ + "static/media/carta_32.e3ce66eb.jpg";